import { useSyncExternalStore } from 'react'

function subscribe(onChange: () => void) {
  document.addEventListener('fullscreenchange', onChange)

  return () => document.removeEventListener('fullscreenchange', onChange)
}

function getFullscreenElement() {
  return document.fullscreenElement instanceof HTMLElement ? document.fullscreenElement : undefined
}

// Conteneur des portals Radix (dialogs, sheets, menus) : l'élément promu en plein écran quand il y en a
// un, le <body> par défaut sinon (undefined). En plein écran, le navigateur n'affiche QUE le sous-arbre
// de l'élément promu : un portal monté dans le <body> s'ouvrirait invisible derrière lui (cf.
// SynopticFullscreenProvider). Suivi sur `fullscreenchange`, pour qu'un portal ouvert bascule avec le plein écran.
export function usePortalContainer(): HTMLElement | undefined {
  return useSyncExternalStore(subscribe, getFullscreenElement, () => undefined)
}
